import { AxiosRestApplicationClient as GeoDataRestApplicationClient } from '@g2-shared/api-client/generated/financial-service-provider-app';
import {
  getOnboardingServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

// Country
export const FETCH_BANKS = `FETCH_BANKS`;

export const financialServiceApiDefaultConfig = {
  retry: undefined,
};

export const useFinancialServiceApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...financialServiceApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getOnboardingServerErrorMessage(error));
      logError(error, 'Error while calling financial service api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const financialServiceApiClient = new GeoDataRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
